module.exports = __webpack_public_path__ + "static/media/logo-rectangle.c65f29bd.svg";